import cn from 'classnames';
import styles from './PrimaryButton.module.scss';

export type PrimaryButtonProps = Omit<
    React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    'onClick'
> & {
    children: React.ReactNode;
    variant?: 'outlined' | 'contained' | 'text';
    size?: 'normal' | 'min' | 'micro';
    color: 'blue' | 'orange' | 'purple';
    fullWidth?: boolean;
    onClick?: () => void;
    mt?: string;
    mb?: string;
    ml?: string;
    mr?: string;
    style?: React.CSSProperties;
};

const PrimaryButton = ({
    children,
    variant = 'contained',
    size = 'normal',
    color,
    fullWidth = false,
    onClick,
    mt,
    mb,
    ml,
    mr,
    className,
    style = {},
    ...rest
}: PrimaryButtonProps) => {
    const btnStyles = cn(className, styles['primary-button'], {
        [styles['primary-button_min']]: size === 'min',
        [styles['primary-button_micro']]: size === 'micro',
        [styles.contained]: variant === 'contained',
        [styles.outlined]: variant === 'outlined',
        [styles.text]: variant === 'text',
        [styles['contained_purple']]: color === 'purple' && variant === 'contained',
        [styles['contained_orange']]: color === 'orange' && variant === 'contained',
        [styles['contained_blue']]: color === 'blue' && variant === 'contained',
        [styles['outlined_purple']]: color === 'purple' && variant === 'outlined',
        [styles['outlined_orange']]: color === 'orange' && variant === 'outlined',
        [styles['outlined_blue']]: color === 'blue' && variant === 'outlined',
        [styles['text_purple']]: color === 'purple' && variant === 'text',
        [styles['text_orange']]: color === 'orange' && variant === 'text',
        [styles['text_blue']]: color === 'blue' && variant === 'text',
    });

    return (
        <button
            className={btnStyles}
            style={{
                marginTop: mt ? mt : '',
                marginBottom: mb ? mb : '',
                marginLeft: ml ? ml : '',
                marginRight: mr ? mr : '',
                width: fullWidth ? '100%' : 'fit-content',
                ...style,
            }}
            onClick={onClick}
            {...rest}
        >
            {children}
        </button>
    );
};

export default PrimaryButton;
